import React from 'react';
import PropTypes from 'prop-types';
import { ListDetailViewProvider } from 'Components/ComponentLibrary/Organisms/ListDetailView/Context';
import List from 'Components/ComponentLibrary/Organisms/ListDetailView/List';
import { FDStack } from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import DetailView from './DetailView';

export default function ListDetailView({
  listCollectionSelfLink,
  setActiveTabResourceType,
}) {
  return (
    <ListDetailViewProvider listCollectionSelfLink={listCollectionSelfLink}>
      <FDStack direction={'row'} height={'100%'} spacing={1}>
        <FDStack overflow={'auto'} width={'100%'} height={'100%'} maxWidth={400}>
          <List />
        </FDStack>
        <FDStack overflow={'auto'} width={'100%'} height={'100%'}>
          <DetailView setActiveTabResourceType={setActiveTabResourceType} />
        </FDStack>
      </FDStack>
    </ListDetailViewProvider>
  );
}

ListDetailView.propTypes = {
  listCollectionSelfLink: PropTypes.object.isRequired,
  setActiveTabResourceType: PropTypes.func,
};

ListDetailView.defaultProps = {
  setActiveTabResourceType: noop,
};
